import {StateCodesVue} from '@/enums/StateCodes.enum';

/** Full name of a German state code (BW → Baden-Württemberg); empty when unknown */
export function stateName(code?: string | null): string {
  if (!code) {
    return '';
  }
  return StateCodesVue.find((state) => state.value === code)?.text || code;
}

/** "Bruchsal (BW)" style place label */
export function placeWithState(city?: string | null, code?: string | null): string {
  if (!city) {
    return code || '';
  }
  return code ? `${city} (${code})` : city;
}
